<template>
  <div class="main-content">
    <div class="section__content section__content--p30">
      <div class="container-fluid">
        <div class="overview-wrap m-b-35">
          <h2 class="title-1">
            {{ text('Encoding Profiles') }} <span v-if="profiles.length">({{ profiles.length }})</span>
          </h2>
          <v-btn color="success" @click="newProfile()">
            <i class="zmdi zmdi-plus p-r-10"></i>{{ text('add_profile') }}
          </v-btn>
        </div>
        <div class="main-card mb-3 card card-shadowed">
          <div class="card-body">
            <table class="mb-0 profile-table table-hover table-striped">
              <thead>
              <tr>
                <th></th>
                <th>{{ text('title') }}</th>
                <th>{{ text('codecs') }}</th>
                <th class="col200">{{ text('resolution') }}</th>
                <th class="col200">{{ text('video_bitrate') }}</th>
                <th>{{ text('audio_bitrate') }}</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(profile, i) of profiles"
                  :key="profile.id"
                  @click="showProfileDetail(profile.id)">
                <td>#{{ i+1 }}</td>
                <td class="profile-name">{{ profile.name }}</td>
                <td class="text-uppercase">
                  {{ profile.video_template.codec }} / {{ profile.audio_template.codec }}
                </td>
                <td colspan="2">
                  <table class="streams">
                    <tr v-for="stream of profile.video_template.streams" :key="stream.id">
                      <td>{{ stream.resolution || 'Same as source' }}</td>
                      <td>{{ stream.bitrate }} Kbps</td>
                    </tr>
                  </table>
                </td>
                <td>{{ profile.audio_template.bitrate }} Kbps</td>
              </tr>
              <tr v-if="!profiles.length && !loading" class="no-hover">
                <td colspan="6" class="text-center">
                  {{ text('no_profiles') }}
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  created() {
    if (this.currentProject === 'live-transcoding') {
      this.routerPrefix = 'Live';
    }
    this.$store.commit('setPageLoader');
    this.$store.dispatch('encodingProfiles/getProfiles')
      .catch((errorMsg) => {
        this.$toasted.error(errorMsg, {
          theme: 'toasted-primary',
          position: 'top-center',
          duration: 10000,
        });
      })
      .finally(() => this.$store.commit('resolvePageLoader'));
  },
  data() {
    return {
      routerPrefix: '',
    };
  },
  computed: {
    loading() {
      return this.$store.getters.isDataLoaded;
    },
    profiles() {
      return this.$store.getters['encodingProfiles/getProfiles'];
    },
    currentProject() {
      return this.$store.getters.projectCode;
    },
    dict() {
      return this.$store.getters.dictionary;
    },
  },
  methods: {
    newProfile() {
      this.$router.push({ name: `${this.routerPrefix}EncodingProfileNewPage` });
    },
    showProfileDetail(id) {
      this.$router.push({
        name: `${this.routerPrefix}EncodingProfileDetailPage`,
        params: {
          id,
        },
      });
    },
    text(code) {
      // eslint-disable-next-line no-prototype-builtins
      if (this.dict.hasOwnProperty(code)) {
        return this.dict[code];
      }
      return code;
    },
  },
};
</script>
